module.exports = __webpack_public_path__ + "static/filter-ce3de4fa56a0446f1b9c9724799c12f8.png";